import React, { useState, useEffect } from 'react';
import { User, Note } from '../types';
import { initialNotes, lessons } from '../data/mockData';
import { useLanguage } from '../i18n/LanguageContext';

interface NotesPageProps {
  user: User | null;
}

const NotesPage: React.FC<NotesPageProps> = ({ user }) => {
    const { t } = useLanguage();
    const [userNotes, setUserNotes] = useState<Note[]>([]);

    useEffect(() => {
        if (user) {
            // In a real app, this would be a fetch call
            setUserNotes(initialNotes.filter(n => n.user_id === user.id));
        } else {
            setUserNotes([]);
        }
    }, [user]);

    if (!user) {
        return (
            <div className="container mx-auto max-w-2xl text-center">
                <div className="bg-white/60 p-8 sm:p-12 rounded-4xl shadow-lg border border-white/50">
                    <h2 className="text-2xl font-bold mb-4">{t('notesPage.loginPromptTitle')}</h2>
                    <p className="text-stone-600">{t('notesPage.loginPrompt')}</p>
                </div>
            </div>
        );
    }
    
    return (
        <div className="container mx-auto max-w-3xl">
            <h1 className="text-4xl font-bold mb-8 text-center">{t('notesPage.title')}</h1>
            {userNotes.length > 0 ? (
                <div className="space-y-6">
                    {userNotes.map(note => {
                        const lesson = lessons.find(l => l.slug === note.lesson_slug);
                        return (
                            <div key={note.id} className="bg-white/60 p-6 rounded-3xl shadow-lg border border-white/50">
                                {lesson && <p className="font-bold text-accent mb-2">{lesson.title}</p>}
                                <p className="text-stone-800 whitespace-pre-wrap">{note.content}</p>
                                <p className="text-sm text-stone-500 mt-3">{new Date(note.timestamp).toLocaleString()}</p>
                            </div>
                        );
                    })}
                </div>
            ) : (
                 <div className="text-center p-10 border-2 border-dashed border-stone-300 rounded-3xl">
                    <p className="text-stone-600">{t('notesPage.noNotes')}</p>
                </div>
            )}
        </div>
    );
};

export default NotesPage;